import { render } from "./allClients.vue?vue&type=template&id=4f524a91"
import script from "./allClients.vue?vue&type=script&lang=js"
export * from "./allClients.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/extra-storage/fundraise/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__